import { motion } from 'motion/react';

import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import styles from './Message.module.css';

import hum from '../../assets/images/hum.webp';

const Message = ({
  message,
  authorFontSize,
  winId,
  isWinner,
  currentId,
  user,
}) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  const avatar = message?.image?.includes(`${user}_${message.channel}`)
    ? iconsSources[message?.channel]
    : (message?.image !== '1' && message?.image) ||
      iconsSources[message?.channel] ||
      hum;

  return (
    <div className={styles.wrapper}>
      {message && (
        <motion.div
          animate={{ opacity: isWinner && winId !== currentId ? 0 : 1 }}
          transition={{
            opacity: { duration: 0.5, delay: 0.4 },
            scale: { duration: 0.5, delay: 0.4 + 0.68 },
          }}
          className={styles.blockMsg}
        >
          <motion.div className={styles.avatar}>
            <div
              className={styles.avatarBg}
              style={{
                background: `url(${
                  iconsSources[message?.channel]
                }) center/cover no-repeat `,
              }}
            />
            <img src={avatar} alt={message?.author} onError={errorHandler} />
          </motion.div>
          <motion.div
            className={styles.nameAuthor}
            style={{ fontSize: `${authorFontSize}rem` }}
          >
            {message?.author || hideNumber(message?.senderNumber)}
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default Message;
